<template>
	<o-alert
		v-if="setup.hasPackBilling"
		class="signature-balance-alert"
		:color="setup.lowBalancies.length ? 'warning' : 'info'">
		<div class="signature-balance-alert__content">
			<div>
				<h4 class="signature-balance-alert__title">
					{{
						setup.lowBalancies.length
							? `Attention au nombre de signatures restantes`
							: `Vos réserves de signatures sont suffisantes`
					}}
				</h4>
				<div v-if="setup.lowBalancies.length">
					Certaines de vos agences sont passées sous le seuil d'alerte.<br>
					Nous vous invitons à commander un pack de signatures pour réapprovisionner vos agences.
				</div>
			</div>
			<o-button
				:color="setup.lowBalancies.length ? 'warning' : 'info'"
				@click="setup.openSignatureBalanceRepartitionAside()">
				Voir les signatures restantes
			</o-button>
		</div>
	</o-alert>
</template>

<script setup lang="ts">
import DashboardSignatureBalanceAlertSetupService from '@/setup/dashboard/DashboardSignatureBalanceAlertSetupService';
const setup = new DashboardSignatureBalanceAlertSetupService();
</script>

<style scoped lang="less">
.signature-balance-alert {
	&__title {
		margin-bottom: 0;
    color: inherit;

		+ div {
			margin-top: 0.9rem;
		}
	}

	&__content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
}
</style>
